import {DrawerProps} from '@mantine/core';
import {FormDrawer} from './FormDrawer.tsx';
import {useTestDefinition} from '../hooks/useTestDefinition.ts';
import {buildInitialValues} from '../forms/buildInitialValues.ts';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useTestDefinition();

    // Empty defaults. `status` is deliberately NOT seeded — the author picks it
    // explicitly and the schema requires it.
    const seededRecord = buildInitialValues();

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
